import React, { useState } from 'react';
import { Dialog } from './Dialog';
import { PaymentForm } from '../Payment/PaymentForm';
import { PaystackScript } from '../Payment/PaystackScript';
import { Check } from 'lucide-react';
import { Button } from './Button';
import { Link } from 'react-router-dom';
interface PaymentDialogProps {
  isOpen: boolean;
  onClose: () => void;
}
export const PaymentDialog = ({
  isOpen,
  onClose
}: PaymentDialogProps) => {
  const [paymentStatus, setPaymentStatus] = useState<'pending' | 'success'>('pending');
  const [reference, setReference] = useState('');
  const handleSuccess = (reference: string) => {
    setReference(reference);
    setPaymentStatus('success');
  };
  const handleClose = () => {
    // Reset state when dialog closes
    if (paymentStatus === 'success') {
      setTimeout(() => {
        setPaymentStatus('pending');
        setReference('');
      }, 300);
    }
    onClose();
  };
  return <>
      <PaystackScript data-id="element-1408" data-mp="3ufa7ry8n0l02" />
      <Dialog isOpen={isOpen} onClose={handleClose} title={paymentStatus === 'success' ? 'Payment Successful' : 'Join The Networking Salon'} size="md" data-id="element-1409" data-mp="3udfwlbn64796">
        <div className="p-4" data-id="element-1410" data-mp="1b2tym2n6bt3e">
          {paymentStatus === 'pending' ? <PaymentForm onSuccess={handleSuccess} data-id="element-1411" data-mp="1ova0h04c9l2q" /> : <div className="text-center py-6" data-id="element-1412" data-mp="1ou036d5b8gx5">
              <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4" data-id="element-1413" data-mp="1ktoij0cy6glo">
                <Check size={32} className="text-gray-700" data-id="element-1414" data-mp="x3u5oismos1f" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-1415" data-mp="x5yijq8i91du">
                Payment Successful
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-1416" data-mp="165bk7wqe0lo0">
                Thank you for joining The Networking Salon Inner Circle!
              </p>
              <p className="text-sm text-gray-500 mb-6" data-id="element-1417" data-mp="1145r3xstewdy">
                Reference: {reference}
              </p>
              <p className="text-gray-600 mb-6" data-id="element-1418" data-mp="2hi4cd8n3bc4l">
                We've sent a confirmation email with details about your
                membership.
              </p>
              <Link to="/join-the-salon" onClick={handleClose} data-id="element-1419" data-mp="1a6ep48h0sr8v">
                <Button className="w-full" data-id="element-1420" data-mp="1f6asc5hw8end">Join The Salon</Button>
              </Link>
            </div>}
        </div>
      </Dialog>
    </>;
};